<h3>Uitloggen</h3>
<p>Weet u zeker dat u wilt uitloggen?</p>
<button mat-raised-button color="warn" [mat-dialog-close]="true">Ja</button>
<button mat-button mat-dialog-close class="deny">Nee</button>